import { render, staticRenderFns } from "./PayrollAdminPage.vue?vue&type=template&id=cbf379a4&scoped=true"
import script from "./PayrollAdminPage.vue?vue&type=script&lang=js"
export * from "./PayrollAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf379a4",
  null
  
)

export default component.exports